import React from 'react'
import Nav from '../Nav'
import Footer from '../Footer'

function OrderPage() {
  return (
    <>
    <Nav />

    <Footer/>
    </>
  )
}

export default OrderPage
